module.exports = __webpack_public_path__ + "img/logo_white.d8a5804f.png";